import { render, staticRenderFns } from "./DsBadge.vue?vue&type=template&id=2ba22f66&scoped=true&"
import script from "./DsBadge.vue?vue&type=script&lang=js&"
export * from "./DsBadge.vue?vue&type=script&lang=js&"
import style0 from "./DsBadge.vue?vue&type=style&index=0&id=2ba22f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba22f66",
  null
  
)

export default component.exports